<script lang="ts" setup>
import { computed } from 'vue'
import { useRouter } from 'vue-router/composables'
import { v4 as uuid } from 'uuid'
import ModuleCard from './ModuleCard.vue'
import { useElementClick } from '@/composables/tracks'
import { resources } from '@/config/brands'

interface Props {
  module: any
  config?: any
  cardClass?: string
  headerClass?: string
}

const props = defineProps<Props>()

const { elementClick } = useElementClick()
const router = useRouter()
const books = computed(() => {
  if (props.module?.resourceList?.records?.length > 12)
    return props.module.resourceList.records.slice(0, 12)

  return props.module?.resourceList?.records || []
})

function gotoCollection() {
  elementClick(`seeall_${props.module.id}`)
  router.push({ name: 'ranking', params: { columnId: props.module.id }, query: { title: props.module.showName } })
}

// 根据索引获取勋章图标
function getMedalIcon(index: number) {
  if (index === 0)
    return resources.medals.goldMedal
  if (index === 1)
    return resources.medals.silverMedal
  if (index === 2)
    return resources.medals.bronze
  return resources.medals.medal
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config?.texts?.seeAll || 'See All'"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="gotoCollection"
  >
    <div class="container">
      <div v-for="(book, index) in books" :key="index">
        <router-link
          :to="{ name: 'book', params: { contentId: book.id } }" replace
          class="flex w-285px relative"
        >
          <div class="absolute left-3px top-2px w-20px shrink-0 flex items-center justify-center z-1">
            <img :src="getMedalIcon(index)" width="100%" height="100%">
            <div class="absolute z-1 text-white text-12px top-6px">
              {{ index + 1 }}
            </div>
          </div>
          <div class="w-81px aspect-3/4 border-rd-8px overflow-hidden shrink-0">
            <BizBookCover
              :id="uuid()"
              :src="book.contentCoverUrl || ''"
              :extra="{
                module_name: module.showName,
                module_id: module.id,
                module_type: module.columnType,
                author: book.authorInfo.author,
                ...book,
              }"
              class="w-full h-full"
            />
          </div>
          <div class="ml-3 flex-1 overflow-hidden">
            <div class="font-500 line-clamp-2 text-n-text-1">
              {{ book.contentName }}
            </div>
            <p class="text-13px mt-10px line-clamp-1 text-n-text-3">
              {{ book.introduce }}
            </p>
            <div class="overflow-hidden">
              <BizShowTags v-if="book.tagList && book.tagList.length" :tags="book.tagList" class="mt-10px" />
            </div>
          </div>
        </router-link>
      </div>
    </div>
  </ModuleCard>
</template>

<style scoped>
.container {
  display: grid;
  grid-auto-flow: column;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
  gap: 10px;
  margin-top: 16px;
  overflow-x: scroll;
}
</style>
